import { render } from "./ForeignJournal.vue?vue&type=template&id=17964b2f"
import script from "./ForeignJournal.vue?vue&type=script&lang=js"
export * from "./ForeignJournal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__